import { render, staticRenderFns } from "./RedCrossSVG.vue?vue&type=template&id=49d92352&scoped=true&"
import script from "./RedCrossSVG.vue?vue&type=script&lang=js&"
export * from "./RedCrossSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d92352",
  null
  
)

export default component.exports